import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { auth, db } from "../FirebaseConfig"; // Import Firestore configuration
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import {createUserWithEmailAndPassword} from "firebase/auth"
import { nanoid } from "nanoid";
import login_background from "./login_background.jpg";
import triteklogo from "./triteklogo.png";

const Registration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false); // Snackbar visibility state
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    const { name, email, password } = formData;
  
    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    // List of allowed email providers
    const allowedEmailDomains = [
      "gmail.com",
      "yahoo.com",
      "outlook.com",
      "hotmail.com",
      "icloud.com",
    ];
  
    // Validate input fields
    if (!name || !email || !password) {
      setError("All fields are required.");
      setOpenSnackbar(true);
      return;
    }
  
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      setOpenSnackbar(true);
      return;
    }
  
    // // Validate email domain
    // const emailDomain = email.split("@")[1];
    // if (!allowedEmailDomains.includes(emailDomain)) {
    //   setError("Please use an email from a main email provider (e.g., Gmail, Yahoo, Outlook).");
    //   setOpenSnackbar(true);
    //   return;
    // }
  
    try {
      // Register user with Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      // Generate referral ID
      const referralId = `${name.split(" ").join("").toLowerCase()}-${nanoid(6)}`;
  
      // User data for Firestore
      const influencerData = {
        name,
        email,
        referralId,
        role: "user", // Default role
        createdAt: new Date().toISOString(),
        uid: user.uid,
      };
  
      // Save user data in Firestore
      const userDocRef = doc(collection(db, "influencers"), user.uid);
      await setDoc(userDocRef, influencerData);
  
      // Show success message and navigate
      setSuccessMessage("Registration successful!");
      setOpenSnackbar(true);
      setTimeout(() => navigate("/"), 2000); // Redirect to login page
    } catch (err) {
      console.error(err);
      if (err.code === "auth/email-already-in-use") {
        setError("The email address is already in use.");
      } else if (err.code === "auth/weak-password") {
        setError("Password must be at least 6 characters.");
      } else {
        setError("Failed to register. Please try again.");
      }
      setOpenSnackbar(true);
    }
  };
    
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Grid container>
      {/* Registration Form Section */}
      <Grid
  item
  xs={12}
  sm={6}
  sx={{
    backgroundColor: "#f7f7f7",
    display: { xs: "none", sm: "flex" }, // Hide on mobile (xs)
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <Box component="img" src={login_background} alt="Registration" sx={{ maxWidth: "100%" }} />
</Grid>
<Grid
  item
  xs={12}
  sm={6}
  sx={{
    padding: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  }}
>
  <Box sx={{ maxWidth: 400, width: "100%" }}>
  <img
        src={triteklogo}
        width={150}
        />
    <Typography variant="h4" sx={{ mb: 2, color: "#7D4AEA", fontWeight: "bold" }}>
     Join us today!
    </Typography>

    <TextField
      fullWidth
      variant="outlined"
      label="Name"
      name="name"
      sx={{ mb: 2 }}
      value={formData.name}
      onChange={handleInputChange}
    />
    <TextField
      fullWidth
      variant="outlined"
      label="Email"
      name="email"
      type="email"
      sx={{ mb: 2 }}
      value={formData.email}
      onChange={handleInputChange}
    />
    <TextField
      fullWidth
      variant="outlined"
      label="Password"
      name="password"
      type="password"
      sx={{ mb: 2 }}
      value={formData.password}
      onChange={handleInputChange}
    />

    <Button
      fullWidth
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "#7D4AEA",
        color: "#fff",
        "&:hover": { backgroundColor: "#643AB0" },
      }}
      onClick={handleRegister}
    >
      Register
    </Button>
    <br></br>
    <br></br>
    <Typography variant="body2" align="center">
            Back to{" "}
            <Link
              href="/"
              to={'/'}
              underline="hover"
              sx={{ color: "#7D4AEA", fontWeight: "bold" }}
            >
             Login
            </Link>
          </Typography>
  </Box>
</Grid>


      {/* Snackbar for Error or Success Messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={error ? "error" : "success"}
          variant="filled"
          onClose={handleCloseSnackbar}
          sx={{ width: "100%" }}
        >
          {error || successMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default Registration;
